import Layout from '../views/Layout.vue'
export default {
  path: '/square',
  name: '标准空间',
  component: Layout,
  iconCls: 'el-icon-user-solid',
  roles: ['AppUser'],
  hidden: false,
  children: [
    {
      path: '/square',
      component: () =>
                import('../views/square/index'),
      name: '标准化应用空间',
      roles: ['AppUser'],
      hidden: false
    },
    {
      path: '/square/details',
      component: () =>
                import('../views/square/details/index.vue'),
      name: '空间正文', // 空间介绍-正文
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/square/design',
      component: () =>
                import('../views/square/design/index'),
      name: '在线设计',
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/roam',
      component: () =>
                import('../views/square/roam/index'),
      name: '漫游',
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/square/set',
      component: () =>
                import('../views/square/set/index.vue'),
      name: '编辑页', // 空间介绍-正文
      roles: ['AppUser'],
      hidden: true
    }
  ]
}
